import React from 'react';
import styled from 'styled-components';

import telegramIcon from '../images/TelegramIcon.png';

export const TelegramButtonComponent = () => {
  return (
    <TelegramButtonWrapper>
      <a href="https://t.me/iconswap">
        <TelegramButton>
          <TelegramImage src={telegramIcon} alt="telegram" />
          <TelegramButtonText>Join us on Telegram</TelegramButtonText>
        </TelegramButton>
      </a>
    </TelegramButtonWrapper>
  );
};

export default TelegramButtonComponent;

const TelegramButtonWrapper = styled.div`
  display: none;
  @media (max-width: 414px) {
    display: flex;
    justify-content: center;
    margin-top: 29.5px;
    padding-right: 20px;
  }
`;

const TelegramButton = styled.button`
  @media (max-width: 414px) {
    :focus {
      outline: none;
    }
    border: none;
    height: 51px;
    width: 225px;
    border-radius: 4px;
    background-color: #ffffff;
    border: 1px solid #007d81;
  }
`;

const TelegramImage = styled.img`
  @media (max-width: 414px) {
    height: 25px;
    width: 25px;
    margin-right: 5px;
  }
`;

const TelegramButtonText = styled.span`
  @media (max-width: 414px) {
    font-family: 'Avenir Next Medium';
    font-size: 15px;
    color: #007d81;
  }
`;
